<template>
    <div>
        <app-title text="Tareas abiertas" />
        <app-task-filters
            @filter="onFilter"
            @clean="resetFilters"
            :assigned-users="assignedUsers"
            :creators="creators"
        />
        <app-task-list
            :data="tasks"
            @create-note="startCreateNote"
            :on-change-page="onChangePage"
            @sort="onSort"
        />

        <!-- INICIO popUp's -->
        <app-pop-up title="Agregar nota a la tarea" id="add-comment-task" :onClose="cleanNoteForm">
            <div slot="body">
                <app-add-note-task v-if="selectedTask"
                    id="add-comment-task"
                    :task="selectedTask" 
                    :on-save="onSaveNote"
                />
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" :disabled="inProgress" @click="saveNote"> Guardar</button>
            </div> 
        </app-pop-up>
        <!-- FIN popUp's -->
    </div>
</template>
<script>
import TaskList from './OpenTasksList/OpenTasksList.vue';
import TaskFilters from './OpenTaskFilters/OpenTaskFilters.vue';
import NotesTask from '../NotesTask/NotesTaskList/NotesTask.vue';
import AddNoteTask from '../NotesTask/AddNoteTask/AddNoteTask.vue';
import tasksRepository from '../../../../repositories/tasks.repository.js';
export default {
    components: {
        appTaskList: TaskList,
        appAddNoteTask: AddNoteTask,
        appTaskFilters: TaskFilters
    },

    data(){
        return {
            tasks: '',
            page: 1,
            selectedTask: '',
            sort: {
                sortBy: 'due_date',
                sortDir: 'asc'
            },
            filters: {},
            creators: [],
            assignedUsers: []
        }
    },

    methods: {
        loadTasks(){
            const tr = Object.assign({}, tasksRepository);
            if(this.filters.status === 'solved'){
                const payload = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir }
                tr.getTasks(payload, this.page)
                .then(data => {
                    this.tasks = data;
                })
                .catch(error=> toastr.error('Error al cargar las tareas abietas'));
            }else{
                const payload = {...this.filters, status: 'open', sortBy: this.sort.sortBy, sortDir: this.sort.sortDir }
                tr.getTasks(payload, this.page)
                .then(data => {
                    this.tasks = data;
                })
                .catch(error=> toastr.error('Error al cargar las tareas abietas'));
            }
        },
        loadCreators(){
            const tr = Object.assign({}, tasksRepository);
            tr.getCreators()
            .then(data => {
                this.creators = data;
            })
            .catch(error=> toastr.error('Error al cargar los creadores de las tareas'));
        },
        loadAssignedUsers(){
            const tr = Object.assign({}, tasksRepository);
            tr.getAssignedUsers()
            .then(data => {
                this.assignedUsers = data;
            })
            .catch(error=> toastr.error('Error al cargar los responsables de las tareas abietas'));
        },
        onChangePage(page){
            this.page = page;
            this.loadTasks();
        },
        onFilter(filters){
            this.filters = filters;
            this.loadTasks();
        },
        resetFilters(filters){
            this.filters = {};
            this.page = 1;
            this.loadTasks();
        },
        saveNote(){
            this.$bus.$emit('add-comment-task.save');
        },
        onSaveNote() {
            this.$bus.$emit('add-comment-task.close');
            this.loadTasks();
        },
        cleanNoteForm() {
            this.$bus.$emit('add-comment-task.clean');
        },
        startCreateNote(task){
            this.selectedTask = task;
            this.$bus.$emit('add-comment-task.open');
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadTasks();
        },
        deleteComment(payload) {
            const task = this.tasks.data.find(task => task.id === payload.taskId);

            if(!task) return;

            task.detailsShowing = true;

            task.notes = task.notes.filter(note => note.id !== payload.noteId);
        }
    },

    created(){
        this.loadTasks();
        this.loadAssignedUsers();
        this.loadCreators();
        this.$bus.$on('task-note.delete', this.deleteComment);
    }
}
</script>
